// Re-assign Patient picks a schedule entry. Since Bug 6307 the schedule search also returns provider lines (another
// provider's block/pain job on an entry, IsProviderLine): they repeat the entry under the anesthesiologist, and picking
// one would set the job's physician to that provider, so they are left out here.
export const scheduleEntriesOnly = (items) =>
    (items || []).filter(item => !(item && item.AppointmentInfo && item.AppointmentInfo.IsProviderLine));



// WEBPACK FOOTER //
// ./src/components/reassignPatientList.js